import { SHIFTS_SAGA_GET_USERS_WITH_AVAILABILITY, SHIFTS_SAGA_PLAN_AVAILABILITY_USER_TO_SHIFT } from '../actionTypes'
import { GetUsersWithAvailabilityAction, PlanAvailabilityUserToShiftAction } from './shiftsModels'

export const getUsersWithAvailability = (
    canViewAbsences = true,
    canViewLeaveOfAbsences = true,
): GetUsersWithAvailabilityAction => ({
    type: SHIFTS_SAGA_GET_USERS_WITH_AVAILABILITY,
    canViewAbsences,
    canViewLeaveOfAbsences,
})

export const planAvailabilityUserToShift = (
    shiftId: string,
    userId: string,
): PlanAvailabilityUserToShiftAction => ({
    type: SHIFTS_SAGA_PLAN_AVAILABILITY_USER_TO_SHIFT,
    shiftId,
    userId,
})
